import type { ISparePartsDashboardFilters } from '@/types/rc/filters'
import type { PartReplacementPayload, UndoPartReplacmentPayload } from '@/types/rc/miners/PartService'
import axios from 'axios'

/**
 * Replaces a miner part with a spare part.
 *
 * @param minerId ID of miner that owns part to replace.
 * @param data part replacement payload.
 * @returns updated details.
 */
export const replacePart = async (minerId: number, data: PartReplacementPayload) => {
  const res = await axios.put(`${import.meta.env.VITE_APP_RC_MINERS_ENDPOINT}/${minerId}/parts/replacement`, data)
  return res.data
}

/**
 * Undo a part replacement.
 *
 * @param minerId ID of miner this part belongs to.
 * @param data replacement payload.
 * @returns updated details.
 */
export const undoPartReplacement = async (minerId: number, data: UndoPartReplacmentPayload) => {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_MINERS_ENDPOINT}/${minerId}/parts/replacement`, {
    data,
  })
  return res.data
}

/**
 * Retrieves the Spare Part CSV associated with the provided filters
 *
 * @param filters spare part filters.
 */
export async function getSparePartsExportCSV(filters: ISparePartsDashboardFilters): Promise<Blob> {
  const res = await axios.get(`${import.meta.env.VITE_APP_RC_SPARE_PARTS_ENDPOINT}/export`, {
    params: filters,
    responseType: 'blob',
  })
  return res.data
}

/**
 * Delete a collection of spare parts
 *
 * @param spare_part_ids the spare parts ids to delete
 */
export async function bulkDeleteSpareParts(ids: number[]): Promise<unknown> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_SPARE_PARTS_ENDPOINT}/bulk`, {
    data: { spare_part_ids: ids },
  })
  return res.data
}

/**
 * Archive a collection of spare parts
 *
 * @param spare_part_ids the spare parts ids to archive
 */
export async function bulkArchiveSpareParts(ids: number[]): Promise<unknown> {
  const res = await axios.patch(`${import.meta.env.VITE_APP_RC_SPARE_PARTS_ENDPOINT}/bulk/archive`, {
    spare_part_ids: ids,
  })
  return res.data
}
